import IconCharge from  "../../../common/assets/icons/charge.png";
import IconPayment from  "../../../common/assets/icons/payment.png";
import { TransactionTypeCharge } from "../../payments/logics/getTransactions";
import "../styles/AccountTransactionsItemTableData.css";

interface IAccountTransactionsItemTableData {
  type: number,
  date: string | null,
}

const options = {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
}; 

export const AccountTransactionsItemTableData = ({type, date}: IAccountTransactionsItemTableData) => {
  return (
    //@ts-ignore
    <div className="a_atitd_main_con">
      <img src={type == TransactionTypeCharge ? IconCharge : IconPayment} className="a_atitd_img"></img>
      <div className="a_atitd_period_con">
        <span className="a_atitd_period_name">{type == TransactionTypeCharge ? "Начислено за ЖКУ" : "Выполнен платеж за ЖКУ"}</span>
       {//@ts-ignore
       
        <span className="a_atitd_period_amount">{ date ? (new Date(date)).toLocaleString("ru", options) : ""}</span>}
      </div>
    </div>
  );
};

